import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { localizations, getLanguage } from "./component/localization";

window.YaGames.init().then(function (ysdk) {
  window.ysdk = ysdk;
  window.addEventListener("focus", function (e) {
    window.ysdk.features.GameplayAPI.start();
  });

  window.addEventListener("blur", function (e) {
    window.ysdk.features.GameplayAPI.stop();
  });

  window.ysdk.features.LoadingAPI.ready();
  window.addEventListener("contextmenu", function (e) {
    e.preventDefault();
  });
  window.addEventListener("doubleclick", function (e) {
    e.preventDefault();
  });
  window.ysdk.features.GameplayAPI.stop();
  window.ysdk.adv.showFullscreenAdv({
    callbacks: {
      onClose: function (wasShown) {
        window.ysdk.features.GameplayAPI.start();
        document.querySelector("#title").textContent =
          localizations.name[getLanguage()];
        ReactDOM.render(
          <React.StrictMode>
            <App />
          </React.StrictMode>,
          document.getElementById("root")
        );
      },
      onError: function (error) {},
    },
  });
});
